import React from "react";
import DetalleCard from "~business/Cards/DetalleCard.tsx";
import { useDispatch, useSelector } from "react-redux";
import SecurityIcon from "@mui/icons-material/Security";
import ItemInputCard from "~business/Cards/ItemInputCard.tsx";

import {
  setNombreConductor,
  setApellidoConductor,
  setNumeroDocumentoConductor,
  setSubmitting,
} from "../actions";
import { toPascalCase } from "~libs/stringsPascalCase";
import { isDni } from "~libs/validators";

const useReduxSelector = () =>
  useSelector((state) => ({
    nombreConductor: state.cargaSiniestroPublicaReducer.nombreConductorSelected,
    apellidoConductor:
      state.cargaSiniestroPublicaReducer.apellidoConductorSelected,
    numeroDocumentoConductor:
      state.cargaSiniestroPublicaReducer.numeroDocumentoConductorSelected,
  }));

const title = "Datos del Conductor";

const DatosConductorCard = ({ isLoading }) => {
  const dispatch = useDispatch();

  const { nombreConductor, apellidoConductor, numeroDocumentoConductor } =
    useReduxSelector();

  let timer = null;

  const handleChangeNombreConductor = (nombre) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNombreConductor(nombre));
    }, 200);
  };

  const handleChangeApellidoConductor = (apellido) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setApellidoConductor(apellido));
    }, 200);
  };

  const handleChangeNumeroDocumentoConductor = (dni) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(setNumeroDocumentoConductor(dni));
    }, 200);
  };

  const handleBlur = () => {
    dispatch(setSubmitting(false));
  };

  return (
    <>
      <DetalleCard title={title} IconHeader={SecurityIcon}>
        <ItemInputCard
          id={"nombreConductor"}
          isLoading={isLoading}
          label={"Nombre"}
          value={nombreConductor.value}
          onChange={handleChangeNombreConductor}
          onBlur={handleBlur}
          focus={nombreConductor.focus}
          required
          formatValue={toPascalCase}
        />
        <ItemInputCard
          id={"apellidoConductor"}
          isLoading={isLoading}
          label={"Apellido"}
          value={apellidoConductor.value}
          onChange={handleChangeApellidoConductor}
          onBlur={handleBlur}
          focus={apellidoConductor.focus}
          required
          formatValue={toPascalCase}
        />
        <ItemInputCard
          id={"documento"}
          isLoading={isLoading}
          label={"Número de Documento"}
          value={numeroDocumentoConductor.value}
          onChange={handleChangeNumeroDocumentoConductor}
          onBlur={handleBlur}
          focus={numeroDocumentoConductor.focus}
          required
          numbersOnly
          customValidate={isDni}
          placeholder="Ej: 12345678"
        />
      </DetalleCard>
    </>
  );
};

export default DatosConductorCard;
